import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Types
import { CheckActivationCodeValidityAndTrialMode, UseActivationCodeResponse } from '../../../shared/types/manageCalls';

// Services
import { WebServiceCaller } from '../../services/webservice-caller/webservice-caller.service';

@Injectable()
export class ActivationCodeService {
  private readonly wsCaller = inject(WebServiceCaller);

  useActivationCode(activationCode: string): Observable<UseActivationCodeResponse> {
    return this.wsCaller.postCall('useActivationCode', { activationCode });
  }

  checkActivationCodeValidity(): Observable<CheckActivationCodeValidityAndTrialMode> {
    return this.wsCaller.postCall('checkActivationCodeValidity');
  }
}
